<div class="col-12-nav">
    <ngx-spinner bdColor="rgba(51,51,51,0.55)"
                 size="medium"
                 color="#fff"
                 type="line-spin-clockwise-fade"
                 [fullScreen]="false">
        <p class="loading">{{ 'general.loading' | translate }}...</p>
    </ngx-spinner>
    <div class="signin-header">
        <div class="container">
            <section class="logo center-block-wrap">
                <div class="logo-white"></div>
            </section>
        </div>
    </div>
    <div class="img-background login-content">
        <br>
        <div class="col-12 text-right">
            <a tabindex="0" id="en" class="btn btn-default border border-left-0 border-top-0 border-bottom-0 border-dark rounded-0" (click)="translateFunc.useLanguage('en')" aria-hidden="false">EN <span class="sr-only">Change language to English</span> </a>
            <a tabindex="0" id="es" class="btn btn-default" (click)="translateFunc.useLanguage('es')" aria-hidden="false">ES <span class="sr-only">Cambiar idioma a español</span></a>
        </div>
        <div class="login-box">
            <div class="col-12">
            <form (submit)="loginUser($event)" [formGroup]="loginForm"
                  [ngClass]="{ 'was-validated': formSubmitted }">
                <div class="form form-group">
                    <label for="Email">{{'general.email' | translate}}<span class="error">*</span></label>
                    <input id="Email" type="text" formControlName="Email" class="form-control input-creds"
                           required="required" [ngClass]="{ 'is-valid': Email['valid'],'is-invalid': Email['invalid'] }" />
                    <ng-container *ngIf="loginForm.get('Email').invalid && (formSubmitted || loginForm.get('Email').touched || loginForm.get('Email').dirty)">
                        <div *ngIf="loginForm.get('Email').hasError('required')"  class="error align-left">
                            {{'general.required_field' | translate}}
                        </div>
                        <div *ngIf="loginForm.get('Email').hasError('pattern')"  class="error align-left">
                            {{'general.invalid_email' | translate}}
                        </div>
                    </ng-container>
                    <div id="emailErr" [innerHtml]="emailErr"></div>
                </div>
                <br>
                <div class="form form-group mb-4">
                    <label for="Password">{{'password.password' | translate}}<span class="error">*</span></label>
                    <input id="Password" type="password" formControlName="Password" class="form-control input-creds"
                           required="required" [ngClass]="{ 'is-valid': Password['valid'], 'is-invalid': Password['invalid'] }" />
                    <ng-container *ngIf="loginForm.get('Password').invalid && (loginForm.get('Password').touched || loginForm.get('Password').dirty || formSubmitted)">
                        <div *ngIf="loginForm.get('Password').hasError('required')"  class="error align-left">
                            {{'general.required_field' | translate}}
                        </div>
                    </ng-container>
                    <div id="passErr" class="error" [innerHtml]="passErr"></div>
                </div>
                <div class="form form-group">
                    <div class="text-center mb-2 error" id="err" [innerHtml]="err"></div>
                    <input id="login" type="submit" class="btn btn-alertia btn-green btn-h-green btn-login" title="{{'general.login' | translate}}" value="{{'general.login' | translate}}">
                </div>
            </form>
            </div>
            <br>
            <div class="text-center">
                <a class="custom-hyperlink" href="/forgotPassword"><u>{{'password.forgot_pass' | translate}}</u></a>
                <!-- <span class="h6"> | </span>
                <a class="custom-hyperlink" href="/register"><u>{{'register.no_account' | translate}}</u></a> -->
            </div>
        </div>
        <div class="footer">
            <a class="custom-hyperlink" href="/privacyPolicy" target="_blank" rel="noopener"><u>{{'register.privacy_policy' | translate}}<span class="screen-reader-only">({{'general.opens_new_tab' | translate}})</span><i class="fa fa-external-link ml-2" aria-hidden="true"></i></u></a>
            <span class="h6"> | </span>
            <a class="custom-hyperlink" href="/termsService" target="_blank" rel="noopener"><u>{{'register.terms_of_service' | translate}}<span class="screen-reader-only">({{'general.opens_new_tab' | translate}})</span><i class="fa fa-external-link ml-2" aria-hidden="true"></i></u></a>
            <span class="h6"> | </span>
            <a class="custom-hyperlink" href="/accessibilityStatement" target="_blank" rel="noopener"><u>{{'accessibility.accessibility_statement' | translate}}<span class="screen-reader-only">({{'general.opens_new_tab' | translate}})</span><i class="fa fa-external-link ml-2" aria-hidden="true"></i></u></a>
            <br>
            ©2025 Alertia. {{'general.all_rights' | translate}} - Version 1.2.0
        </div>
    </div>
</div>
